import { IconGlobe } from '@hawkins/assets';
import { Button, Menu, MenuItem } from '@hawkins/components';

import { isDeployProdEnv, SUPPORTED_LANGUAGES } from '../../utils';
import classes from './LanguageSelector.module.css';

interface LanguageSelectorProps {
  onLanguageSelected?: { (s: string): void };
  hideSelectedLanguage?: boolean;
  disabled?: boolean;
  locale?: string;
}

export function LanguageSelector({
  onLanguageSelected = () => '',
  hideSelectedLanguage = false,
  disabled = false,
  locale = 'en',
}: LanguageSelectorProps) {
  // Given language map and languages to remove
  // will remove if in prod
  const deleteIfProd = (
    langMap: { [index: string]: string },
    toRemove: string[]
  ) => {
    if (!isDeployProdEnv()) {
      return Object.keys(langMap).filter((loc) => !toRemove.includes(loc));
    }
    return Object.keys(langMap);
  };

  const removeFromProd: string[] = [];
  const languages = deleteIfProd(SUPPORTED_LANGUAGES, removeFromProd);

  return (
    <Menu
      showCaret
      disabled={disabled}
      trigger={
        <Button
          aria-label={'language_selector_help'}
          icon={IconGlobe}
          variant="tertiary"
        >
          {locale && !hideSelectedLanguage ? SUPPORTED_LANGUAGES[locale] : null}
        </Button>
      }
    >
      {languages.map((loc, i) => {
        return (
          <MenuItem
            key={`lang-${i}`}
            className={classes.languageSelectorMenuItem}
            onClick={() => onLanguageSelected(loc)}
            selectType="single"
            selected={locale === loc}
          >
            {SUPPORTED_LANGUAGES[loc]}
          </MenuItem>
        );
      })}
    </Menu>
  );
}
